import { connect } from 'react-redux';
import PodcastsView from './index'
import {loadPodcasts, removePodcast} from '../../actions/Podcasts'
const mapStateToProps = (state, props) => {

    return {
	podcasts: state.podcasts.list,
	authenticated: state.session.authenticated
    }
}

const mapDispatchToProps = (dispatch, state) => {
    return {
	loadPodcasts: () => dispatch(loadPodcasts()),
	removePodcast: (id) => dispatch(removePodcast(id)).then(() => dispatch(loadPodcasts())),

    }
}

const PodcastsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PodcastsView);


export default PodcastsContainer;



// WEBPACK FOOTER //
// ./src/components/Podcasts/Container.js